/** Join id references for aria-describedby / aria-labelledby, dropping blanks. */
export const joinIds = (...ids: (string | undefined | null | false)[]): string | undefined => {
  const present = ids.filter((id): id is string => typeof id === 'string' && id.length > 0);
  return present.length === 0 ? undefined : present.join(' ');
};
